import Axios from 'axios';
import { API_URL } from '../../../constants/Constants';

export const api_delete_target_group = async (targetGroupId: number) : Promise<boolean> => {
    
    const url = API_URL+'/target_group/'+targetGroupId;
    const config = {
        'Access-Control-Allow-Origin': API_URL,
        withCredentials: true 
    }
    await Axios.delete(
        url,
        config
    )
    return true;
}
